import { Outlet } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { lazy, Suspense, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useSwitchLanguage from 'src/hooks/useSwitchLanguage';
import useAuth from 'src/hooks/useAuth';
import Footer from 'src/components/Footer';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const PMDWrapper = Loader(lazy(() => import('remotePMD/PMDWrapper')));

const RemotePMDLayout = () => {
  const { switchContainerLanguage } = useSwitchLanguage();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();

  useEffect(() => {
    // get language from sharing link and update container lang
    const lang = searchParams.get('lang');
    if (lang) switchContainerLanguage(lang);
  }, []);

  return (
    <>
      <PMDWrapper user={user}>
        <Outlet />
      </PMDWrapper>
      <Footer />
    </>
  );
};

export default RemotePMDLayout;
